import { call, delay, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { resetPasswordActions } from "../slices";
import { has } from "lodash";
import { showSuccessToast } from "@helpers";

function* resetPasswordWorker({ payload }) {
  try {
    yield put(resetPasswordActions.pending());
    const response = yield call(authApi.resetPassword, payload);
    yield put(resetPasswordActions.success(response));
    // TODO: handle callback | onSuccess
    if (has(payload, "onSuccess")) {
      yield call(payload.onSuccess);
    }
    yield delay(300);
    yield call(showSuccessToast, "Reset password successfully!");
  } catch (error) {
    yield put(resetPasswordActions.failure(error));
    // TODO: handle callback | onFailure
    if (has(payload, "onFailure")) {
      payload.onFailure();
    }
  }
}

export { resetPasswordWorker };
